var hasProp = window.hasProp;
var extend = window.extend;
var bind = window.bind;
var bind = function (fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
  extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
AcademiaSharing.BookmarkButtonView = function (superClass) {
  extend(BookmarkButtonView, superClass);
  function BookmarkButtonView() {
    this.remove_on_toast = bind(this.remove_on_toast, this);
    return BookmarkButtonView.__super__.constructor.apply(this, arguments);
  }
  BookmarkButtonView.prototype.initialize = function () {
    BookmarkButtonView.__super__.initialize.apply(this, arguments);
    this.set_model(this.options.model || this.build_model(this.options.model_options));
    return this;
  };
  BookmarkButtonView.prototype.set_model = function (model) {
    this.model = model;
    this.model.on('sync', function (_this) {
      return function () {
        return _this.set_bookmarked();
      };
    }(this));
    return this.model.on('destroy', function (_this) {
      return function () {
        _this.model.unset('id');
        return _this.set_unbookmarked();
      };
    }(this));
  };
  BookmarkButtonView.prototype.build_model = function (model_options) {
    var model_arx, reshare_of, source, source_details;
    model_arx = this.$el.data("academia-share");
    reshare_of = this.$el.parents('.work_share_container').data("reshare-of");
    source = (model_options != null ? model_options.source : void 0) || this.$el.data("share-source");
    source_details = (model_options != null ? model_options.source_details : void 0) || this.$el.data("share-source-details");
    if (source_details == null && this.$el.data("share-source-details-news-story-verb")) {
      source_details = {
        story_verb: this.$el.data("share-source-details-news-story-verb")
      };
    }
    return AcademiaSharing.Bookmark.for_target_arx(model_arx, {
      share_id: reshare_of,
      source: source,
      source_details: source_details
    });
  };
  BookmarkButtonView.prototype.handle_bookmark_click = function () {
    if (this.model.id) {
      return this.handle_remove();
    } else {
      return this.handle_save();
    }
  };
  BookmarkButtonView.prototype.handle_remove = function () {
    if (this.$el.data('hide-remove-confirmation') === true) {
      return this.model.destroy();
    } else {
      return $w.confirm("Paper bookmarked. Remove it?", {
        nextTo: this.$el
      }, function (_this) {
        return function () {
          return _this.model.destroy();
        };
      }(this));
    }
  };
  BookmarkButtonView.prototype.remove_on_toast = function (callback) {
    return this.model.destroy({
      success: function (_this) {
        return function () {
          return callback();
        };
      }(this)
    });
  };
  BookmarkButtonView.prototype.handle_save = function () {
    return this.model.save({
      message: ''
    }, {
      success: function (_this) {
        return function () {
          return Components.Utils.showToast(Components.Toasts.AutoBookmarkToast, {
            undoBookmark: _this.remove_on_toast,
            linkSettingsOnUndoBookmark: false
          }, {
            timeMs: 4000,
            clickToClose: false,
            color: _this.$el.data("toast-color") || 'Blue'
          });
        };
      }(this)
    });
  };
  BookmarkButtonView.prototype.set_bookmarked = function () {
    if (this.$el.data('no-dom-modification') !== true) {
      this.$el.addClass('after_success').find('*[data-content="button_text"]').text('Bookmarked').addClass('u-tcGrayDarker');
      this.$el.find('*[data-content="button_text_small"]').addClass('u-tcGrayDarker');
      return this.$el.find('.fa-plus').removeClass('fa-plus').addClass('fa-check u-tcGrayDarker');
    }
  };
  BookmarkButtonView.prototype.set_unbookmarked = function () {
    if (this.$el.data('no-dom-modification') !== true) {
      this.$el.removeClass('after_success').find('*[data-content="button_text"]').text('Bookmark').removeClass('u-tcGrayDarker');
      this.$el.find('*[data-content="button_text_small"]').removeClass('u-tcGrayDarker');
      return this.$el.find('.fa-check').removeClass('fa-check u-tcGrayDarker').addClass('fa-plus');
    }
  };
  return BookmarkButtonView;
}(Academia.View);
window.bind = bind;
window.extend = extend;
window.hasProp = hasProp;